import * as Actions from '../actions';

const initialState = {
    dashboard_layout: [],
    grid_layout: [],
};

const dashboardReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_LAYOUT):
            {
                // Generates React-Grid layout
                let { dashboard_layout, is_folded } = action.payload;

                const grid_layout = dashboard_layout.map((widget_info) => {
                    return {
                        i: String(widget_info.auth_dashboard_id),
                        w: widget_info.Width,
                        h: widget_info.Height,
                        x: widget_info.X,
                        y: widget_info.Y,
                        minH: 2,
                        minW: 2,
                    };
                });

                return {
                    ...state,
                    dashboard_layout: dashboard_layout,
                    grid_layout: grid_layout,
                }
            }

        case (Actions.SET_DASHBOARD_LAYOUT):
            // console.log(action.payload)
            {

                return {
                    ...state,
                    grid_layout: action.payload,
                }
            }

        default:
            {
                return state;
            }
    }
};

export default dashboardReducer;


// WEBPACK FOOTER //
// src/main/content/dashboard/store/reducers/dashboard.reducer.js